import React, { useState, useRef } from 'react';
import '../scss/cp.scss';
import Logo from '../images/logo.png';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import routes from '../../layout/Routes';

const products = [
  { title: "Careena AI", desc: "Patient onboarding & KYC agent" },
  { title: "Oculon", desc: "Risk intelligence & decisioning" },
  { title: "Instant Care Checkout", desc: "End-to-end chat checkout" },
  { title: "Pay-in-Parts", desc: "EMI & Non-EMI split-pay" },
  { title: "HopeGuard", desc: "Insurance add-ons" },
  { title: "Reconcile", desc: "Payouts, settlement & ledger" }
];

const solutions = [
  "For Patients",
  "For Clinics & Day-Care Hospitals",
  // "For Enterprise Hospitals & Chains",
  "For Lenders/NBFCs & Insurers",
  // "For Pharma/OEM & D2C Brands",
  // "For Integrators (HIMS/CRMs/PGs)"
];

const Navbar = () => {
    let navigate=useNavigate()
  
  const [productMenu, setProductMenu] = useState(false);
  const [solutionsMenu, setSolutionsMenu] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const hoverTimeoutProduct = useRef(null);
  const hoverTimeoutSolutions = useRef(null);

  const menuHover = (type) => {
    if (type === 'product') {
      if (hoverTimeoutProduct.current) clearTimeout(hoverTimeoutProduct.current);
      setProductMenu(true);
    } else if (type === 'solutions') {
      if (hoverTimeoutSolutions.current) clearTimeout(hoverTimeoutSolutions.current);
      setSolutionsMenu(true);
    }
  };

  const menuLeave = (type) => {
    if (type === 'product') {
      hoverTimeoutProduct.current = setTimeout(() => setProductMenu(false), 200);
    } else if (type === 'solutions') {
      hoverTimeoutSolutions.current = setTimeout(() => setSolutionsMenu(false), 200);
    }
  };

  const toSlug = (text) =>
    text.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-');

  const handleProductClick = (title) => {
    const slug = toSlug(title);
    window.location.href = `/product/${slug}`;
  };

  const handleSolutionClick = (name) => {
    const slug = toSlug(name);
    window.location.href = `/solution/${slug}`;
  };

  return (
    <>
      {/* Desktop Navbar */}
      <nav className="navbar">
        <div className="navbar__logo">
          <img src={Logo} style={{ width: '120px' }} alt="CarePay Logo" onClick={()=>navigate(routes.HOME_PAGE_NEW)} />
        </div>
        <div className="navbar__links">
          {/* Products */}
          <div
            onMouseEnter={() => menuHover('product')}
            onMouseLeave={() => menuLeave('product')}
            style={{ position: 'relative', display: 'inline-block' }}
          >
            <a style={{ display: 'flex', marginTop: '5px' }}>
              Products
              <span className={`arrow${productMenu ? ' open' : ''}`}>
                {productMenu ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </span>
            </a>
            <div className="product-menu-item">
              <div className={`product-menu-dropdown${productMenu ? " open" : ""}`}>
                {products.map((prod, idx) => (
                  <div
                    key={idx}
                    className="product-menu-dropdown-item"
                    onClick={() => handleProductClick(prod.title)}
                  >
                    <div className="product-menu-dropdown-title">{prod.title}</div>
                    <div className="product-menu-dropdown-desc">{prod.desc}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Solutions */}
          <div
            onMouseEnter={() => menuHover('solutions')}
            onMouseLeave={() => menuLeave('solutions')}
            style={{ position: 'relative', display: 'inline-block' }}
          >
            <a style={{ display: 'flex', marginTop: '5px' }}>
              Solutions
              <span className="arrow">
                {solutionsMenu ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </span>
            </a>
            <div className="solutions-menu-item">
              <div className={`product-menu-dropdown${solutionsMenu ? " open" : ""}`}>
                {solutions.map((sol, idx) => (
                  <div
                    key={idx}
                    className="product-menu-dropdown-item"
                    onClick={() => handleSolutionClick(sol)}
                  >
                    <div className="product-menu-dropdown-title">{sol}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <a onClick={()=>navigate(routes.WHY_CAREPAY)}>Why CarePay</a>
          {/* <a onClick={()=>navigate(routes.PRICING)} >Pricing</a> */}
          <a onClick={()=>navigate(routes.OUR_TEAM)}>Team</a>
        </div>
        <div className="navbar__cta">
          <button className="demo-btn" onClick={()=>navigate(routes.CAREPAY_DEMO)}>Get a Demo</button>
        </div>

        {/* Hamburger */}
        <button
          className={`navbar-mobile__hamburger ${mobileMenuOpen ? 'open' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>

      {/* Backdrop */}
      {mobileMenuOpen && <div className="navbar-backdrop" onClick={() => setMobileMenuOpen(false)}></div>}

      {/* Mobile Drawer */}
      <div className={`navbar-mobile ${mobileMenuOpen ? 'open' : ''}`}>
        {/* Close Button */}
        <div className="navbar-mobile__close" onClick={() => setMobileMenuOpen(false)}>
          <CloseIcon />
        </div>

        <div
          className="navbar-mobile__item"
          onClick={() => setProductMenu(!productMenu)}
        >
          Products {productMenu ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </div>
        {productMenu && (
          <div className="navbar-mobile__submenu">
            {products.map((prod, idx) => (
              <div
                key={idx}
                className="navbar-mobile__submenu-item"
                onClick={() => handleProductClick(prod.title)}
              >
                <div className="title">{prod.title}</div>
                <div className="desc">{prod.desc}</div>
              </div>
            ))}
          </div>
        )}

        <div
          className="navbar-mobile__item"
          onClick={() => setSolutionsMenu(!solutionsMenu)}
        >
          Solutions {solutionsMenu ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </div>
        {solutionsMenu && (
          <div className="navbar-mobile__submenu">
            {solutions.map((sol, idx) => (
              <div
                key={idx}
                className="navbar-mobile__submenu-item"
                onClick={() => handleSolutionClick(sol)}
              >
                {sol}
              </div>
            ))}
          </div>
        )}

        <a onClick={()=>navigate(routes.WHY_CAREPAY)}>Why CarePay</a>
        {/* <a onClick={()=>navigate(routes.PRICING)}>Pricing</a> */}
        <a onClick={()=>navigate(routes.OUR_TEAM)}>Team</a>
        <button className="demo-btn-web" onClick={()=>navigate(routes.CAREPAY_DEMO)}>Get a Demo</button>
      </div>
    </>
  );
};

export default Navbar;
